import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { memo } from 'react';
import { InputNodeForm } from 'pages/assistants/builder/components/forms/inputNodeForm';
import { ModelNodeForm } from 'pages/assistants/builder/components/forms/modelNodeForm';
import { SimpleMailInputNodeForm } from 'pages/assistants/builder/components/forms/simpleMailInputNodeForm';
import { LlmAdvisorNodeForm } from 'pages/assistants/builder/components/forms/llmAdvisorNodeForm';
import { AdvisorNodeForm } from 'pages/assistants/builder/components/forms/advisorNodeForm';
import { LogAdvisorNodeForm } from 'pages/assistants/builder/components/forms/logAdvisorNodeForm';
import { GroovyNodeForm } from 'pages/assistants/builder/components/forms/groovyNodeForm';
import { ClassificationNodeForm } from 'pages/assistants/builder/components/forms/classificationNodeForm';
import { SwitcherNodeForm } from 'pages/assistants/builder/components/forms/switcherNodeForm';
import { SimpleMailOutputNodeForm } from 'pages/assistants/builder/components/forms/simpleMailOutputNodeForm';
import { KnowledgeBaseNodeForm } from 'pages/assistants/builder/components/forms/knowledgeBaseNodeForm';
import { LongContextModelNodeForm } from 'pages/assistants/builder/components/forms/longContextModelNodeForm';
import { PromptNodeForm } from 'pages/assistants/builder/components/forms/promptNodeForm';
import { AccountNodeForm } from 'pages/assistants/builder/components/forms/accountNodeForm';
import { OutputNodeForm } from 'pages/assistants/builder/components/forms/outputNodeForm';

export const NodeFormsFactory = memo(function NodeFormsFactory({ node, onUpdateData }) {
  console.debug('NodeFormsFactory render:', node);

  switch (node?.type) {
    case 'userInput': {
      return <InputNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }
    case 'model': {
      return <ModelNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }
    case 'mailInput': {
      return (
        <SimpleMailInputNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />
      );
    }
    case 'documentAdvisor': {
      return <LlmAdvisorNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'rewriteAdvisor': {
      return <LlmAdvisorNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'memoryAdvisor': {
      return <AdvisorNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'logAdvisor': {
      return <LogAdvisorNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'groovyProcessor': {
      return <GroovyNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'classificationProcessor': {
      return <ClassificationNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'switcherProcessor': {
      return <SwitcherNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'mailOutput': {
      return (
        <SimpleMailOutputNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />
      );
    }

    case 'knowledgeBase': {
      return <KnowledgeBaseNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'longContextModel': {
      return (
        <LongContextModelNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />
      );
    }
    case 'prompt': {
      return <PromptNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'account': {
      return <AccountNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    case 'userOutput': {
      return <OutputNodeForm id={node?.id} data={node?.data} onUpdateData={onUpdateData} />;
    }

    default:
      return (
        <>
          <Box>{node?.type}</Box>
          <Box>{node?.data?.label}</Box>
        </>
      );
  }
});

NodeFormsFactory.propTypes = {
  node: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};
